import React, { useRef, useState, useEffect } from "react";
import { Modal, Form, Divider } from "antd";
import { Button, Input, Row, Col, Select, DatePicker, Table } from "antd";
import { CloseOutlined, FormOutlined } from "@ant-design/icons";
import Axios from "../../../api/Axios";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;
const { Option } = Select;

const CustomerSwitch = ({
  CreateSuccessfull,
  CreateFailed,
  onCancel,
  visible,
  id,
  passData,
}) => {
  console.log(passData);
  const [applications, setApplications] = useState([]);

  useEffect(() => {
    if (visible && id) {
      const fetchApplications = async () => {
        try {
          const res = await Axios.get(`/customer/parentapplications/?customer_id=${id}`);
          if (res.data && res.data.data) {
            setApplications(res.data.data);
            if (res.data.data.length === 1 && formRef.current) {
              formRef.current.setFieldsValue({
                application_ids: [res.data.data[0].id]
              });
            }
          }
        } catch (error) {
          console.error("Failed to fetch applications", error);
        }
      };
      fetchApplications();
    } else if (!visible) {
      setApplications([]);
    }
  }, [visible, id]);
  const formRef = useRef();
  const handleCancel = () => {
    formRef.current.resetFields();
    onCancel();
  };

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");

  const onFinish = async (values) => {
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );

    // Remove the 'dateRange' field from the normalizedValues object
    delete normalizedValues.dateRange;

    // Retrieve the selected dates from the 'dateRange' field
    const selectedDates = values.dateRange;
    //console.log(selectedDates, "selectedDates");
    if (selectedDates && selectedDates.length > 0) {
      const contract_start_date = selectedDates[0].format("YYYY-MM-DD");
      normalizedValues.start_date = contract_start_date;
      if (selectedDates.length === 2 && selectedDates[1] !== null) {
        const contract_end_date = selectedDates[1].format("YYYY-MM-DD");
        normalizedValues.end_date = contract_end_date;
      }
    }
    try {
      await Axios.put(`/customertoclient/${id}/`, normalizedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      CreateSuccessfull("Created");
    } catch (err) {
      //console.log(err);
      CreateFailed("");
    }
  };
  const [isUserIDExists, setIsUserIDExists] = useState(false);
  const handleFormChange = async (changedValues, allValues) => {
    if (
      "trainery_client_id" in changedValues &&
      allValues.trainery_client_id.length > 2
    ) {
      const response = await Axios.get(
        `/orgcheck/?search=${allValues.trainery_client_id}`
      );
      //console.log(response);
      setIsUserIDExists(response.data.exists);
    }
    // if ("naics_primary" in changedValues && allValues.naics_primary.length > 3) {
    //   const response = await Axios.get(
    //     `/naicslist/?search=${allValues.naics_primary}`
    //   );
    //   console.log(response);
    //   setNaicsRes(response.data);
    // }
  };
  const checkUserIDExists = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserIDExists === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserIDExists().then(resolve, reject);
        }, 100);
      } else if (isUserIDExists) {
        reject("Client ID already exists");
      } else {
        resolve();
      }
    });
  };
  const defaultDateRange = [dayjs(), dayjs().add(60, "day")];

  const columns = [
    { title: "User ID", dataIndex: "user_id", key: "user_id" },
    { title: "Full Name", dataIndex: "full_name", key: "full_name" },
    { title: "Email", dataIndex: "email", key: "email", width: 250 },
    {
      title: "Phone No",
      dataIndex: "phone_number",
      key: "phone_number",
      width: 150,
    },
  ];

  return (
    <Modal
      // title="My Modal"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      title={<p className="modal-heading">Switch Customer To Client</p>}
      centered
      width={800}
    >
      {passData?.length > 0 && (
        <>
          <div style={{ marginInline: "10px" }}>
            <p
              className="my-form-lables"
              style={{ paddingTop: "10px", paddingBottom: "5px" }}
            >
              Contacts to be Switched :{" "}
              <strong style={{ color: "black" }}> {passData?.length}</strong>
            </p>
            <Table
              dataSource={passData}
              columns={columns}
              pagination={false}
              // rowSelection={{
              //   ...rowSelection,
              //   columnTitle: (
              //     <input
              //       type="checkbox"
              //       className="small-checkbox"
              //       checked={selectedKeys.length === passData.length}
              //       onChange={(e) => {
              //         const checked = e.target.checked;
              //         setSelectedKeys(
              //           checked ? passData.map((item) => item.key) : []
              //         );
              //       }}
              //     />
              //   ),
              // }}
              className="table-container"
              size="small"
              scroll={{ x: "max-content", y: 500 }} // Hide scrollbar until overflow
            />
          </div>
          <Divider />
        </>
      )}
      <Form
        name="complex-form"
        onFinish={onFinish}
        layout="vertical"
        ref={formRef}
        onValuesChange={handleFormChange}
        labelCol={{
          span: 25,
        }}
        wrapperCol={{
          span: 80,
        }}
        style={{
          width: "100%",
        }}
      >
        <div style={{ marginTop: "2rem" }}>
          <Row gutter={10} style={{ marginLeft: "2rem", marginRight: "2rem" }}>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <Form.Item label={<p className="my-form-lables">Client ID</p>}>
                <Form.Item
                  name="trainery_client_id"
                  rules={[
                    {
                      required: true,
                      message: "Client ID is required",
                    },
                    {
                      max: 20,
                      message: "Must be less than 20 characters ",
                    },
                    {
                      validator: checkUserIDExists,
                      validateTrigger: "onChange",
                    },
                  ]}
                  noStyle
                >
                  <Input
                    placeholder="Enter Client ID"
                    name="trainery_client_id"
                    className="my-form-input-antd-test"
                  />
                </Form.Item>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={10} lg={10} xl={10}>
              <Form.Item
                label={<p className="my-form-lables">Relationship Type</p>}
              >
                <Form.Item
                  name="client_type"
                  noStyle
                  rules={[
                    {
                      required: true,
                      message: "Relationship Type is required",
                    },
                  ]}
                  initialValue={"Prospect"}
                >
                  <Select
                    className="my-form-input-antd-test"
                    placeholder="Select Type"
                    style={{ borderRadius: "0.5rem" }}
                    // onChange={handleRelationShipTypeChange}
                  >
                    <Option value={"Client"}>Client</Option>
                    <Option value={"Prospect"}>Prospect</Option>
                  </Select>
                </Form.Item>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={10} style={{ marginLeft: "2rem", marginRight: "2rem" }}>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<p className="my-form-lables">Start and End Date</p>}
              >
                <Form.Item
                  name="dateRange"
                  noStyle
                  initialValue={defaultDateRange}
                  rules={[
                    {
                      required: true,
                      message: "Date is required",
                    },
                  ]}
                >
                  <RangePicker
                    placeholder={["Start Date", "End Date"]}
                    name="dateRange"
                    className="my-form-input-antd-test"
                    allowClear={false}
                    format="MMM-DD-YYYY"
                  />
                </Form.Item>
              </Form.Item>
            </Col>
            {applications && applications.length > 0 && (
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label={<p className="my-form-lables">Application</p>}
                >
                  <Form.Item
                    name="application_ids"
                    noStyle
                    rules={[
                      {
                        required: true,
                        message: "Application is required",
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      allowClear
                      className="my-form-input-antd-test my-form-input-multiple"
                      placeholder="Select Application(s)"
                      style={{ borderRadius: "0.5rem" }}
                      optionLabelProp="label"
                    >
                      {applications.map((app) => (
                        <Option key={app.id} value={app.id} label={app.name}>
                          <div style={{ display: "flex", alignItems: "center", padding: "4px 0" }}>
                            {app.logo && (
                              <img
                                src={app.logo}
                                alt={app.name}
                                style={{
                                  width: "60px",
                                  height: "24px",
                                  marginRight: "12px",
                                  objectFit: "contain",
                                  objectPosition: "left center"
                                }}
                              />
                            )}
                            <span style={{ fontWeight: 500 }}>{app.name}</span>
                          </div>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Form.Item>
              </Col>
            )}
          </Row>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            height: "2rem",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          <Form.Item style={{ marginRight: "1rem" }}>
            <Button key="back" onClick={handleCancel}>
              <CloseOutlined />
              Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                background: "#f58029",
                fontWeight: "600",
              }}
              className="save-update-btn"
              // disabled={isSaveDisabled}
            >
              Save
              <FormOutlined />
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default CustomerSwitch;
